import { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { ToggleButton } from 'primereact/togglebutton';
import { Button } from 'semantic-ui-react';
import { getAccessCodePageMetaData as getAccessCodePageMetaDataSvc } from 'app/services/accessCodePages';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import ResourceModal from 'app/components/ResourceModal';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

const AccessCodeMetaDataForm = (props) => {
    const { isOpen, onClose, center, accessCodePage, onFormSubmit } = props;
    const [data, setData] = useState([]);
    let title = props.title || 'Metadata';
    let message = props.message;
    let unmountOnClose = true;
    let action = 'update';

    useEffect(async () => {
        if (accessCodePage) {
            var metaData = await getAccessCodePageMetaDataSvc(accessCodePage.id);
            setData(metaData);
        }
    }, [isOpen])

    const requiredBodyTemplate = (rowData) => {
        return rowData.required ? 'Yes' : 'No';
    }

    const onRowEditComplete = (e) => {
        const _data = [...data];
        const { newData, index } = e;
        _data[index] = newData;
        setData(_data);
    }

    const onSave = (params) => {
        const _accessCodePage = Object.assign({}, accessCodePage);
        _accessCodePage.metadata = params;
        _accessCodePage.allow_metadata = params.length > 0;
        onFormSubmit(action, _accessCodePage);
        onClose();
    }

    const onAddRow = () => {
        const _data = [...data];
        _data.push({ field: '', data_type: 'Text', required: false });
        setData(_data);
    }

    const onDeleteRow = (rowIndex) => {
        const _data = [...data];
        _data.splice(rowIndex, 1);
        setData(_data);
    }

    const textEditor = (options) => {
        return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
    }

    const boolEditor = (options) => {
        return <ToggleButton checked={options.value} onChange={(e) => options.editorCallback(e.value)} />;
    }

    const dataTypeEditor = (options) => {

        const dataTypeOptions = [
            { text: 'Text', value: 'Text' },
            { text: 'Number', value: 'Number' }
        ]
        return <Select
            value={options.value}
            onChange={(e) => {
                options.editorCallback(e.target.value)
            }}>
            {
                dataTypeOptions.map((item) => {
                    return <MenuItem key={item.value} value={item.value}>{item.text}</MenuItem>
                })
            }
        </Select>
    }

    const footerBody = () => {
        return <div>
            <Button onClick={onAddRow}>Add Row</Button>
            <Button onClick={() => onSave(data)}>Save</Button>
        </div>
    }

    const deleteRowBody = (data, row) => {
        return <div>
            <IconButton aria-label="delete" onClick={() => onDeleteRow(row.rowIndex)}>
                <DeleteIcon />
            </IconButton>
        </div>
    }

    return (
        <ResourceModal {...{ isOpen, onClose, title, message, center, unmountOnClose, width: '800px' }}>
            <DataTable dataKey='id' value={data} editMode='row' tableStyle={{ minWidth: '50rem' }} scrollable
                onRowEditComplete={onRowEditComplete} footer={footerBody}>
                <Column field='field' header='Field' editor={(options) => textEditor(options)} />
                <Column field='data_type' header='Data Type' editor={(options) => dataTypeEditor(options)} />
                <Column field='required' header='Required' editor={(options) => boolEditor(options)} body={requiredBodyTemplate} />
                <Column rowEditor headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
                <Column body={deleteRowBody} />
            </DataTable>
        </ResourceModal>
    );
}

export default AccessCodeMetaDataForm;